import {
  ProductSearchSharedActions,
  ProductSearchSharedActionType,
} from "./product-search-shared.actions";
import { ProductSearchSharedState } from "../types/product-search-shared-state/product-search-shared-state.interface";
import { createProductSearchSharedState } from "../types/product-search-shared-state/product-search-shared-state.functions";

export function productSearchSharedReducer(
  state = createProductSearchSharedState(),
  action: ProductSearchSharedActionType
): ProductSearchSharedState {
  switch (action.type) {
    case ProductSearchSharedActions.SearchCategory:
    case ProductSearchSharedActions.SearchSubcategory:
      return {
        ...state,
        loading: true,
      };
    case ProductSearchSharedActions.SearchSubcategorySuccess:
      return {
        ...state,
        subcategories: action.payload,
      };
    case ProductSearchSharedActions.SearchCategorySuccess:
      return {
        ...state,
        categories: action.payload,
      };
    case ProductSearchSharedActions.SearchCategoryFailure:
    case ProductSearchSharedActions.SearchSubcategoryFailure:
      return {
        ...state,
        error: action.payload,
      };
    case ProductSearchSharedActions.ClearCategoryResults:
      return {
        ...state,
        error: null,
        categories: null,
      };
    case ProductSearchSharedActions.ClearSubcategoryResults:
      return {
        ...state,
        error: null,
        subcategories: null,
      };
    default:
      return state;
  }
}
